import { defineStore } from "pinia";
import { ref, computed } from "vue";
import * as FullScreen from "@utils/FullScreen.js";

export const useHardwareStore = defineStore("hardware", () => {
  // State
  const fullScreen = ref(false);
  const online = ref(true);

  // Getters
  const isFullScreen = computed(() => fullScreen.value);
  const isOnline = computed(() => online.value);

  // Actions
  function enterFullScreen() {
    fullScreen.value = true;
    FullScreen.turnOnFullscreen();
  }

  function exitFullScreen() {
    fullScreen.value = false;
    FullScreen.turnOffFullscreen();
  }

  function fullScreenChanged() {
    fullScreen.value = FullScreen.fullscreenOn();
  }

  function setOnline(newOnline) {
    online.value = newOnline;
  }

  return {
    fullScreen,
    online,
    isFullScreen,
    isOnline,
    enterFullScreen,
    exitFullScreen,
    fullScreenChanged,
    setOnline,
  };
});
